import { GoogleOAuthProvider, GoogleLogin as GoogleLoginButton } from '@react-oauth/google';
import axios from 'axios';
import { useAuth } from '../../hooks/useAuth';

const RAW_API_BASE = import.meta.env.VITE_API_URL || 'http://localhost:3002';
const API_BASE = RAW_API_BASE.replace(/\/$/, '').endsWith('/api')
  ? RAW_API_BASE.replace(/\/$/, '')
  : `${RAW_API_BASE.replace(/\/$/, '')}/api`;
const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID || '';

interface GoogleLoginProps {
  onSuccess: () => void;
  onError: (error: string) => void;
}

function GoogleLoginInner({ onSuccess, onError }: GoogleLoginProps) {
  const { login } = useAuth();

  const handleCredential = async (credential: string) => {
    try {
      const response = await axios.post(`${API_BASE}/auth/google`, { token: credential });
      login(response.data.token, response.data.user);
      onSuccess();
    } catch (error: any) {
      console.error('Login failed:', error);
      onError(error.response?.data?.error || 'Login failed');
    }
  };

  return (
    <div className="flex justify-center">
      <GoogleLoginButton
        onSuccess={(response) => {
          if (response.credential) {
            handleCredential(response.credential);
          }
        }}
        onError={() => onError('Google sign-in failed')}
        theme="filled_black"
        size="large"
        shape="rectangular"
        width={350}
        text="signin_with"
        ux_mode="popup"
      />
    </div>
  );
}

export const GoogleLoginComponent: React.FC<GoogleLoginProps> = (props) => {
  if (!GOOGLE_CLIENT_ID) {
    return (
      <div className="p-4 bg-red-900/30 border border-red-500 rounded-lg text-red-200">
        <p className="font-semibold mb-2">Warning: Configuration Error</p>
        <p className="text-sm">GOOGLE_CLIENT_ID is not configured.</p>
        <p className="text-xs mt-2">Please set VITE_GOOGLE_CLIENT_ID in your environment</p>
      </div>
    );
  }

  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <GoogleLoginInner {...props} />
    </GoogleOAuthProvider>
  );
};

export const GoogleLogin = GoogleLoginComponent;
